import { useAuthContext } from "../../../../../context/AuthContext";
import { useLanguageContext } from "../../../../../context/LanguageContext";
import LabelItemParagraph from "../paragraph/ParagraphLabelItem";

export default function VisFieldLabelItem({
  item,
  visitorData,
  printerData,
  readOnly,
}) {
  const authContext = useAuthContext();
  const { translateEntity, translate } = useLanguageContext();
  const data = getData();

  function getData() {
    switch (item.type) {
      case "company_name":
        return authContext?.auth?.user?.company?.name;

      case "location_name":
        return authContext.auth.user?.company?.locations?.find((loc) => {
          const locId = visitorData?.location?.id || visitorData?.location;
          return loc.id === locId;
        })?.name;

      case "location_address":
        return authContext.auth.user?.company?.locations?.find((loc) => {
          const locId = visitorData?.location?.id || visitorData?.location;
          return loc.id === locId;
        })?.address;

      case "visitor_type_name":
        return translateEntity(visitorData?.visitor_type, "label");

      case "language_label":
        return visitorData?.language?.label;

      case "sign_in_terminal_name":
        return visitorData?.sign_in_terminal?.name;

      case "employee_title":
        return visitorData?.employee?.title;

      case "employee_name":
        return visitorData?.employee?.name;

      case "employee_first_name":
        return visitorData?.employee?.first_name;

      case "employee_last_name":
        return visitorData?.employee?.last_name;

      case "email":
        return visitorData?.email;

      case "registration_code":
        return visitorData?.registration_code;

      case "returning":
        return visitorData?.returning
          ? translate(
              `eva.main.general.${visitorData.returning ? "yes" : "no"}`,
            )
          : visitorData?.returning;

      case "expected_date":
        return (
          visitorData?.expected_date_formatted ?? visitorData?.expected_date
        );

      case "expected_end_date":
        return (
          visitorData?.expected_end_date_formatted ??
          visitorData?.expected_end_date
        );

      case "expected_time":
        return (
          visitorData?.expected_time_formatted ?? visitorData?.expected_time
        );

      case "signed_in_at":
        return visitorData?.signed_in_at_formatted ?? visitorData?.signed_in_at;

      case "signed_out_at":
        return (
          visitorData?.signed_out_at_formatted ?? visitorData?.signed_out_at
        );

      case "status":
        return visitorData?.status
          ? translate(`eva.main.visitor_statuses.${visitorData.status}`)
          : visitorData?.status;

      case "salto_user_pin":
        return visitorData?.external_ids?.find(
          (id) => id.name === "salto_user_pin",
        )?.external_id;

      case "access_commander_2n_pin":
        return visitorData?.external_ids?.find(
          (id) => id.name === "vis_access_commander_2n_pin",
        )?.external_id;

      case "license_plate":
        return visitorData?.license_plate;

      default:
        return null;
    }
  }

  return (
    <LabelItemParagraph item={item} printerData={printerData}>
      {readOnly
        ? (data ?? "")
        : `${translate(
            `eva.main.printers.label.item.types.${item.type}`,
          )} (${translate("eva.main.validation.attributes.value")})`}
    </LabelItemParagraph>
  );
}
